import React from "react"
import ContentLoader from "react-content-loader"

const MyLoader = (props) => (
  <ContentLoader 
    speed={2}
    width={400}
    height={160}
    viewBox="0 0 400 160"
    backgroundColor="#f3f3f3"
    foregroundColor="#ecebeb"
    {...props}
  >
    <rect x="83" y="13" rx="3" ry="3" width="254" height="24" /> 
    <rect x="82" y="50" rx="3" ry="3" width="180" height="5" /> 
    <rect x="82" y="62" rx="3" ry="3" width="180" height="6" /> 
    <rect x="81" y="74" rx="3" ry="3" width="180" height="6" /> 
    <rect x="80" y="86" rx="3" ry="3" width="180" height="6" /> 
    <circle cx="57" cy="42" r="15" /> 
    <circle cx="54" cy="159" r="6" />
  </ContentLoader>
)

export default MyLoader